/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Editors_Fixed_CountInputs */

const en_us2_profile_editors_fixed_count = /** @type {(inputs: Profile_Editors_Fixed_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 fixed day`);
	return /** @type {LocalizedString} */ (`${i?.count} fixed days`)
	
};

const pt_br2_profile_editors_fixed_count = /** @type {(inputs: Profile_Editors_Fixed_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia fixo`);
	return /** @type {LocalizedString} */ (`${i?.count} dias fixos`)
	
};

const es_419_profile_editors_fixed_count = /** @type {(inputs: Profile_Editors_Fixed_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 día fijo`);
	return /** @type {LocalizedString} */ (`${i?.count} días fijos`)
	
};

const pt_pt2_profile_editors_fixed_count = /** @type {(inputs: Profile_Editors_Fixed_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia fixo`);
	return /** @type {LocalizedString} */ (`${i?.count} dias fixos`)
	
};

const fr_fr2_profile_editors_fixed_count = /** @type {(inputs: Profile_Editors_Fixed_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 jour fixe`);
	return /** @type {LocalizedString} */ (`${i?.count} jours fixes`)
	
};

const de_de2_profile_editors_fixed_count = /** @type {(inputs: Profile_Editors_Fixed_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 fester Tag`);
	return /** @type {LocalizedString} */ (`${i?.count} feste Tage`)
	
};

const it_it2_profile_editors_fixed_count = /** @type {(inputs: Profile_Editors_Fixed_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 giorno fisso`);
	return /** @type {LocalizedString} */ (`${i?.count} giorni fissi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 fixed day" |
* | * | "{count} fixed days" |
*
* @param {Profile_Editors_Fixed_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_fixed_count = /** @type {((inputs: Profile_Editors_Fixed_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Fixed_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_fixed_count(inputs)
	if (locale === "es-419") return es_419_profile_editors_fixed_count(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_fixed_count(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_fixed_count(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_fixed_count(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_fixed_count(inputs)
	return en_us2_profile_editors_fixed_count(inputs)
});
export { profile_editors_fixed_count as "profile-editors.fixed_count" }